module.exports = __webpack_public_path__ + "static/media/Pickup_drop.2181899b.png";